export default {
  AUCTIONS_LIST: "Liste des encans",
  ADD_AUCTION: "Ajouter un encan",
  VIEW_AUCTION: "Voir l'encan",
  AUCTION_ADDED: "Encan ajouté",
  EDIT_AUCTION: "Modifier l'encan",
  AUCTION_UPDATED: "Ecan mis à jour",
  DELETE_THIS_AUCTION: "Supprimer cet encan ?",
  DELAY: "Délai avant extension",
  AUCTION_TYPE: "Type d'encan",
  NAME: "Nom de l'encan",
  OBJECT_TYPE: "Type d'objet",
  AUTHORIZED_PAYMENTS: "Paiements autorisés",
  PAYMENT_SOURCE_BANK_DRAFT: "Traite bancaire",
  PAYMENT_SOURCE_CERTIFIED_CHECK: "Chèque certifié",
  PAYMENT_SOURCE_POST_ORDER: "Mandat poste",
  PAYMENT_SOURCE_CASH: "Argent comptant",
  PAYMENT_SOURCE_BANK_TRANSFER: "Transfert bancaire",
  PAYMENT_SOURCE_NORMAL_CHECK: "Chèque normale",
  PAYMENT_SOURCE_FIDEOCOMMIS_CHECK: "Chèque fidéicommis",
  PAYMENT_SOURCE_PAYMENT_SOURCE_NORMAL_CHECK: "Chèque normal",
  PRE_OPENING_AT: "Date d'ouverture pré-enchère",
  ACTIVATED_TIMER: "Minuteur activé",
  EXTENSION_TIME: "Temps d'extension",
  OBJECT_TYPE_PROPERTY: "Propriété",
  OBJECT_TYPE_CAR: "Voiture",
  AUCTION_TYPE_STANDARD: "Standard",
  AUCTION_TYPE_SILENT: "Silencieuse",
  TOTAL_PROPERTIES: "Propriétés (total)",
  TOTAL_PROPERTIES_CONFIRMED: "Propriétés confirmés",
  LISTINGS_REGISTRATIONS_OPEN_AT: "Date d’ouverture des inscriptions",
  LISTINGS_REGISTRATIONS_CLOSE_AT: "Date de fermeture des inscriptions",
  ADD_FEE_LEVEL: "Ajouter un palier",
  ADD_BID_STEP: "Ajouter un bond de mise",
  START_AT: "Date début de l'encan",
  UPDATE_FEES: "Actualiser les frais",
  APPLY_FEES: "Appliquer des frais",
  PROPERTIES_FEE_UPDATED:
    "LES FRAIS organisation DES PROPRIÉTÉS DE CET ENCAN ONT ÉTÉ MIS À JOUR",
  ADD_FEES: "Ajouter un frais",
  AMOUNT: "Montant frais",
  PERCENT: "Taux (Pourcentage)",
  REPAIR_BY_NUMBER: "Répartition par nombre",
  FEES_TYPE: "Type de frais",
  FEES_NAME: "Nom du frais",
  FEES_TYPE_NORMAL: 'Normal',
  FEES_TYPE_CLERK_LAW: 'Devoir greffier',
  FEES_TYPE_CONSIGNMENT: 'Consignations',
  FEES_TYPE_AUCTION: 'Enchère',
  FEES_TAB: 'Frais',
  FILES_FEES: 'Frais dossiers',
  DEPOSIT_REQUIRED_TO_BET_ONLINE: 'Dépôt obligatoire pour miser en ligne',
  PLACE: 'Endroit',
  PLACE_ONLINE: 'En ligne',
  PLACE_PHYSIC: 'Physique',
  PLACE_HYBRID: 'Hybride',
  ADVANCE_PAYMENT: 'Paiement accepté avant la vente',
  ADVANCE_PAYMENT_FULL: 'Complet',
  ADVANCE_PAYMENT_PARTIAL: 'Partiel',
  APPLIED_FEE: "Frais Appliqué",
  APPLIED_FEE_PERCENT_LIMIT: "La valeur dans le champ pourcentage ne doit pas dépassée 100",
  PERCENTAGE: "Pourcentage",
  APPLIED_FEE_DATE_REQUIRED: "Le champ date est obligatoire",
  APPLIED_FEE_TYPE_REQUIRED: "Le champ type est obligatoire",
  APPLIED_FEE_AMOUNT_REQUIRED: "Le champ montant est obligatoire",
  APPLIED_FEE_PERCENT_REQUIRED: "Le champ pourcentage est obligatoire",
  FEE_VALUE: "Valeur",
  TOTAL_PROPERTIES_APPLIED_FEE : "La quantité des propriétés (confirmés) qui vont recevoir le frais : ",
  PROPERTIES: "propriétés",
  FEE_AMOUNT_BY_PROPERTY : "Chaque propriété va recevoir : ",
  FEE_FROM_PROPERTY_TAXES : "de son taxes",
  FEE_AMOUNT_BY_PROPERTY_COLUMN: "Frais par propriété",
  STARTING_AMOUNT_AUTOMATIC: "Prix de départ automatique",
  DELAY_BETWEEN_PROPERTIES: "Délai entre chaque enchère",
  UPCOMMING_AUCTIONS: "Prochains évènements à venir"
};
